export default __webpack_public_path__ + "static/media/Blueshift_LE.617ac1b3.jpg";